import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import HouseholdItem from './HouseholdItem'

interface SimilarHouseholdsProps {
	bestHouseholdsData: { label: string; value: number }[]
	type: 'points' | 'savings'
	isLoading: boolean
}

const SimilarHouseholds: FC<SimilarHouseholdsProps> = ({ bestHouseholdsData, type, isLoading }) => {
	const { t } = useTranslation('pages_saving', { keyPrefix: 'similarHouseholds' })

	return (
		<div className='flex flex-col bg-[#f5f5f5] dark:bg-surface-dark rounded-xl py-4 gap-4'>
			<span className='text-base text-center text-text-dark dark:text-white'>{t(type)}</span>
			{bestHouseholdsData.map((item, i) => (
				<HouseholdItem
					key={`${type}-${item.value}-${i}`}
					item={item}
					type={type}
					index={i}
					isLoading={isLoading}
					t={t}
				/>
			))}
		</div>
	)
}

export default SimilarHouseholds
